import React, { useEffect, useState } from "react"
import ReactTooltip from 'react-tooltip'
import {
	PayTypeWrapper,
	PayTypeItem,
	PayTypeImg,
	ItemCount,
	Price,
	ButtonQuantity,
	Count,
	Buttons,
} from "./styled"
import { RegexUtil } from "../../../../../common/utils/regexUtil"
import { objectPayTypeText, getColorPayType } from "./helpers"
import './item.css';

const SelectPayType = ({
	giftable,
	onClickGift,
	arrayPayTypeResult,
	payType,
	cash,
	medal,
	point,
	displayCash,
	displayMedal,
	displayPoint,
	onClickBuy,
}) => {
	const [count, setCount] = useState(1)

	const [payTypeSelected, setPayTypeSelected] = useState(undefined)

	useEffect(() => {
		setPayTypeSelected(arrayPayTypeResult.find((item) => item[1])[0])
	}, [arrayPayTypeResult])

	useEffect(() => {
		setCount(1)
	}, [payTypeSelected])

	const handleClickBuy = () => onClickBuy(count || 1, getColorPayType(payTypeSelected));

	const handleCountChange = (e) => {
		let val = e.target.value.replace(/[^0-9]/g, '');
		if (val === '') {
			setCount('');
		} else {
			if (val.length > 16 || BigInt(val) > 9007199254740991n) {
				val = "9007199254740991";
			} else {
				val = BigInt(val).toString();
			}
			setCount(val);
		}
	};

	const handleCountBlur = () => {
		if (count === '' || count < 1) {
			setCount(1);
		}
	};

	return (
		<PayTypeWrapper>
			{arrayPayTypeResult.map((item, index) => {
				const checked = payTypeSelected === item[0];
				const pay_type = getColorPayType(item[0]);

				return (
							<PayTypeItem
								key={index}
								active={!!item[1]}
								onClick={() => item[1] && setPayTypeSelected(item[0])}
							>
								<PayTypeImg
									checked={checked}
									color={pay_type}
								/>
								{item[1] &&  (
									<div 
										style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }} 
										data-tip={(() => {
											let combinedTooltip = "";
											const displayPrice = BigInt(pay_type === "GOLD" ? (displayCash || 0) : pay_type === "POINT" ? (displayPoint || 0) : (displayMedal || 0));
											const basePrice = BigInt(pay_type === "GOLD" ? cash : pay_type === "POINT" ? point : medal);
											const qty = BigInt(checked ? (count || 1) : 1);
											const unit = objectPayTypeText[item[0]];
											
											if (displayPrice > 0n && displayPrice !== basePrice) {
												combinedTooltip += `<span style='text-decoration:line-through; color:#aaa;'>${RegexUtil.makeComma((displayPrice * qty).toString())} ${unit}</span><br/>`;
											}
											combinedTooltip += `<span style='color:red;'>${RegexUtil.makeComma((basePrice * qty).toString())} ${unit}</span>`;
											return combinedTooltip;
										})()}
										data-html={true}
									>
										{(() => {
											const displayPriceStr = pay_type === "GOLD" ? (displayCash || "0") : pay_type === "POINT" ? (displayPoint || "0") : (displayMedal || "0");
											const displayPrice = BigInt(displayPriceStr);
											const basePrice = BigInt(pay_type === "GOLD" ? cash : pay_type === "POINT" ? point : medal);
											const qty = BigInt(checked ? (count || 1) : 1);
											
											let dFormatted = "";
											if (displayPrice > 0n && displayPrice !== basePrice) {
												dFormatted = RegexUtil.makeComma((displayPrice * qty).toString());
												if (dFormatted.length > 14) {
													dFormatted = dFormatted.substring(0, 14);
													if (dFormatted.endsWith(',')) dFormatted = dFormatted.substring(0, 13);
													dFormatted += '...';
												}
											}

											let formatted = RegexUtil.makeComma((basePrice * qty).toString());
											if (formatted.length > 14) {
												formatted = formatted.substring(0, 14);
												if (formatted.endsWith(',')) formatted = formatted.substring(0, 13);
												formatted += '...';
											}

											return (
												<>
													{dFormatted !== "" && (
														<span style={{ textDecoration: 'line-through', color: '#999', fontSize: '13px', marginBottom: '2px' }}>
															{dFormatted} {objectPayTypeText[item[0]]}
														</span>
													)}
													<Price style={{ padding: 0, margin: 0, width: 'auto' }} color={pay_type} checked={checked}>
														{formatted} {objectPayTypeText[item[0]]}
													</Price>
												</>
											);
										})()}
										<ReactTooltip type="dark" place="bottom" effect="solid" />
									</div>
								)}
								{!item[1] && (
									<div style={{ flex: 1 }}>{objectPayTypeText[item[0]]}{pay_type === "MEDAL" ? "으로" : "로"} 구매불가</div>
								)}
								{checked && (
									<ItemCount>
										<ButtonQuantity
											onClick={() => {
												if (count <= 1) return
												setCount((BigInt(count || 1) - 1n).toString())
											}}
											className={getColorPayType(payTypeSelected)+ ' minus'}
											disabled={count === 1}
										>
										</ButtonQuantity>
										<Count>
											<input
												type="text"
												title={count}
												value={count}
												onChange={handleCountChange}
												onBlur={handleCountBlur}
												style={{
													width: "40px",
													textAlign: "center",
													border: "none",
													background: "transparent",
													fontSize: "inherit",
													color: "inherit",
													fontFamily: "inherit",
													padding: 0,
													outline: "none"
												}}
											/>
										</Count>
										<ButtonQuantity
											onClick={() => {
												if (BigInt(count || 1) >= 9007199254740991n) return
												setCount((BigInt(count || 1) + 1n).toString())
											}}
											className={getColorPayType(payTypeSelected)+ ' plus'}
											style={{ opacity: BigInt(count || 1) >= 9007199254740991n ? 0.3 : 1 }}
										>
										</ButtonQuantity>
									</ItemCount>
								)}
							</PayTypeItem>
				)
			})}
			<Buttons>
				{giftable === "Y" ? (
					<button onClick={() => onClickGift(count || 1, getColorPayType(payTypeSelected))}>선물</button>
				) : (
					""
				)}
				<button className={`buy ${getColorPayType(payTypeSelected)}`} onClick={handleClickBuy}>
					구매
				</button>
			</Buttons>
		</PayTypeWrapper>
	)
}

export default SelectPayType
